import { hcWithType } from 'server/hc';

export const { api } = hcWithType(import.meta.env.PUBLIC_API_URL, {
	init: { credentials: 'include' },
});
